import { FetchAppEndAction } from "../actions/FetchApp";
import { AppState } from "../state";

import { addAppToState, selectApp } from "./Common";

export function fetchApp(state: AppState, action: FetchAppEndAction): AppState {
    let newState = addAppToState(state, action);

    if (action.payload.selectOnSuccess) {
        newState = selectApp(newState, action);
    }

    return newState;
}
